class PagamentoService {
    bancos = {
        "041": "https://ww8.banrisul.com.br/brb/link/Brbw2Lhw_Bloqueto_Titulos_Internet.aspx?SegundaVia=1&secao_id=2539",
        "237": "https://www.ib12.bradesco.com.br/ibpfsegundaviaboleto/segundaViaBoletoPesquisarLinhaDigitavel.do?",
        "104": "https://www.caixa.gov.br/atendimento/2-via-boleto/Paginas/default.aspx",
        "341": "https://www.itau.com.br/servicos/boletos/segunda-via",
        "033": "https://www.santander.com.br/2-via-boleto",
        "756": "https://www.sicoob.com.br/web/sicoob/segunda-via-de-boleto",
        "748": "https://www.sicredi.com.br/segundaviaboleto/",
        "001": "https://www63.bb.com.br/portalbb/boleto/boletos/hc21e,802,3322,10343.bbx",
        "422": "https://wwws.safraempresas.com.br/pjseguro/SacadosConsultaBoletoCobr_NCS.asp?origem=C&stpf=1",
        "085": [
            {
                url: "https://www.transpocred.coop.br/segunda-via-e-atualizacao-de-boletos/",
                search_keys: ["transpo"]
            },
            {
                url: "https://www.viacredi.coop.br/segunda-via-e-atualizacao-de-boletos",
                search_keys: ["viacre"]
            },
        ],
        "133": "https://segundavia.governarti.com.br/pagador",
        "136": "https://unicredportoalegre.cobexpress.com.br/default/segunda-via",
    }

    get_banco_url(numero_banco: number, descricao_banco: string) {
        // Faz a busca pelo número do banco
        const banco = Object.keys(this.bancos).find(b => Number(b) == Number(numero_banco));
        if (!banco) return undefined;

        const banco_url = this.bancos[banco];
        if (Array.isArray(banco_url)) {
            return banco_url.find(b => b.search_keys.some(k => descricao_banco.toLowerCase().includes(k)))?.url;
        }

        return banco_url;
    }
}

export default new PagamentoService();